import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout-v2"
import Seo from "../components/seo"

import HeroSection from "../components/home-components/hero-section"
import HeroSectionFade from "../components/home-components/hero-section-fade"
import Offerings from "../components/home-components/offerings"
import PredictiveMarketing from "../components/home-components/predictive-marketing"
import MovingTitle from "../components/home-components/moving-title-v2"
import SectionOneV2 from "../components/home-components/section-one-v2"
import SectionOneV3 from "../components/home-components/section-one-v3"
import FoodBeverage from "../components/home-components/food-beverage"
import EnergyEssentials from "../components/home-components/energy-essentials"
import DataMiners from "../components/home-components/data-miners"
import UniqueApproach from "../components/home-components/unique-approach"
import DigitalMarketing from "../components/home-components/digital-marketing"
import ExperienceCreators from "../components/home-components/experience-creators"
import OurWork from "../components/home-components/our-work"
import ContactUs from "../components/contact-us"
import PredictiveData from "../components/home-components/predictive-data"
import DataDesignDelivery from "../components/home-components/data-design-delivery"

const IndexPage = ({ data: { pageContent } }) => {
  const content = pageContent.edges

  return (
    <Layout isHomePage>
      {content.map(page => (
        <Seo
          title={page.node.SEOmeta.metaTitle}
          description={page.node.SEOmeta.metaDescription}
          keywords={page.node.SEOmeta.metaKeywords}
          ogTitle={page.node.SEOmeta.ogTitle}
          ogDescription={page.node.SEOmeta.ogDescription}
          ogImage={page.node.SEOmeta.ogImage.localFile.childImageSharp.fluid}
          twitterTitle={page.node.SEOmeta.twitterTitle}
          twitterDescription={page.node.SEOmeta.twitterDescription}
          twitterImage={
            page.node.SEOmeta.twitterImage.localFile.childImageSharp.fluid
          }
        />
      ))}
      {/* <MovingTitle />
            <SectionOneV2 /> */}
      {/* <HeroSection /> */}
      <HeroSectionFade />
      <Offerings />
      <SectionOneV3 />
      {/* <FoodBeverage /> */}
      <PredictiveData />
      {/* <EnergyEssentials /> */}
      <DataDesignDelivery />
      {/* <UniqueApproach />
            <DataMiners />
            <ExperienceCreators />
            <DigitalMarketing /> */}
      <OurWork />
      <ContactUs />
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    pageContent: allWpCustomPage(filter: { databaseId: { eq: 1444 } }) {
      edges {
        node {
          SEOmeta {
            metaTitle
            metaDescription
            metaKeywords
            ogTitle
            ogDescription
            ogImage {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1320, quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            twitterTitle
            twitterDescription
            twitterImage {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1320, quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`
